module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-SPORT-1.f1e77c47.jpg";